import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";

const region = "us-east-1";
const userPoolID = "us-east-1_viYeJWMrP";
const clientID = "455pemko2oldnkks847u7p5s0i";

const cognitoClient = new CognitoIdentityProviderClient({
  region: region,
});

export { cognitoClient, userPoolID, clientID };
